import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import {
  ILetterProjectsResponse,
  IOfficialLettersActionRequest,
  IOfficialLettersActionResponse,
  IOutgoingLettersResponse,
} from "dto/OfficialLetters/IOfficialLetters";

// „Projekty pism" i „Wychodzące pisma" — listy pism autora (port Magistratu:
// NormalProjectsList / OutgoingDocumentsList). BE: api/outgoingParcel/letters/*.

export const officialLettersQueryKeys = {
  all: ["letters"],
  projects: ["letters", "projects"],
  outgoing: ["letters", "outgoing"],
};

const getProjects = (): Promise<{ data: ILetterProjectsResponse }> =>
  axiosInstance.get("outgoingParcel/letters/projects");

const useGetProjects = () =>
  useCustomQuery(officialLettersQueryKeys.projects, getProjects, {
    refetchOnWindowFocus: true,
  });

const getOutgoing = (): Promise<{ data: IOutgoingLettersResponse }> =>
  axiosInstance.get("outgoingParcel/letters/outgoing");

const useGetOutgoing = () =>
  useCustomQuery(officialLettersQueryKeys.outgoing, getOutgoing, {
    refetchOnWindowFocus: true,
  });

const setReadyToDispatch = (
  request: IOfficialLettersActionRequest,
): Promise<{ data: IOfficialLettersActionResponse }> =>
  axiosInstance.post("outgoingParcel/letters/readyToDispatch", request);

const useSetReadyToDispatch = () => useCustomMutation(setReadyToDispatch);

const returnToProject = (
  request: IOfficialLettersActionRequest,
): Promise<{ data: IOfficialLettersActionResponse }> =>
  axiosInstance.post("outgoingParcel/letters/returnToProject", request);

const useReturnToProject = () => useCustomMutation(returnToProject);

const approve = (
  request: IOfficialLettersActionRequest,
): Promise<{ data: IOfficialLettersActionResponse }> =>
  axiosInstance.post("outgoingParcel/letters/approve", request);

const useApprove = () => useCustomMutation(approve);

export default {
  useGetProjects,
  useGetOutgoing,
  useSetReadyToDispatch,
  useReturnToProject,
  useApprove,
};
